"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Button = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _index = _interopRequireDefault(require("./index.styled"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var DEFAULT_STYLE = 'Primary';

var Button = function Button(_ref) {
  var href = _ref.href,
      _ref$id = _ref.id,
      id = _ref$id === void 0 ? '' : _ref$id,
      _ref$children = _ref.children,
      children = _ref$children === void 0 ? 'Button Label' : _ref$children,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? '' : _ref$type,
      _ref$styleType = _ref.styleType,
      styleType = _ref$styleType === void 0 ? DEFAULT_STYLE : _ref$styleType,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '' : _ref$width,
      _ref$target = _ref.target,
      target = _ref$target === void 0 ? '_self' : _ref$target,
      onClick = _ref.onClick;
  var isLink = typeof href !== 'undefined';
  var DynamicTag = isLink ? _index.default.A : _index.default.Button;

  var handleOnClick = function handleOnClick(e) {
    if (typeof onClick === 'function') {
      onClick(e);
    }
  };

  return /*#__PURE__*/_react.default.createElement(DynamicTag, {
    type: type,
    styleType: styleType,
    width: width,
    href: href,
    target: target,
    onClick: handleOnClick,
    "data-testid": "rm-button",
    "data-id": id
  }, children);
};

exports.Button = Button;
Button.propTypes = {
  /**
   * Default width is 100%, override with this prop (eg: '250px')
   **/
  width: _propTypes.default.string,

  /**
   * Button label
   **/
  children: _propTypes.default.string,

  /**
   * set to 'submit' for form submission buttons
   **/
  type: _propTypes.default.string,

  /**
   * Style of button
   */
  styleType: _propTypes.default.oneOf(['Primary', 'Secondary']),

  /**
   * set href to make an A tag instead of a button
   */
  href: _propTypes.default.string,

  /**
   * overwrite to control link behavior
   */
  target: _propTypes.default.string
};